import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AppContainer from './app/App';
import HomeContainer from './views/home';
import ApproveContainer from './views/approve';
import DocSignContainer from './views/docsign';
import UpdateProjectContainer from './views/project';
import ProjectListContainer from './views/projects';
import CreateProjectContainer from './views/create';
import IvyVMContainer from './comboforms/ivyvm';
import VerifyContainer from './views/verify';
import ProvisionContainer from './views/provision';
import UserProvisionContainer from './views/userprovision';
import RotatePIContainer from './views/rotate';
import PromotePIContainer from './views/promote';
import LogContainer from './views/log';

const renderRoot = (props) => (
	<AppContainer {...props}>
		<HomeContainer {...props} />
	</AppContainer>
);

const renderUpdate = (props) => (
	<AppContainer {...props}>
		<UpdateProjectContainer {...props} />
	</AppContainer>
);

const renderLog = (props) => (
	<AppContainer {...props}>
		<LogContainer {...props} />
	</AppContainer>
);

const renderProjects = (props) => (
	<AppContainer {...props}>
		<ProjectListContainer {...props} />
	</AppContainer>
);

const renderRotatePI = (props) => (
	<AppContainer {...props}>
		<RotatePIContainer {...props} />
	</AppContainer>
);

const renderPromotePI = (props) => (
	<AppContainer {...props}>
		<PromotePIContainer {...props} />
	</AppContainer>
);

const renderCreate = (props) => (
	<AppContainer {...props}>
		<CreateProjectContainer {...props} />
	</AppContainer>
);

const renderDocSign = (props) => (
	<AppContainer {...props}>
		<DocSignContainer {...props} />
	</AppContainer>
);

const renderApproval = (props) => (
	<AppContainer {...props}>
		<ApproveContainer {...props} />
	</AppContainer>
);

const renderIvyVM = (props) => (
	<AppContainer {...props}>
		<IvyVMContainer {...props} />
	</AppContainer>
);

const renderVerify = (props) => (
	<AppContainer {...props}>
		<VerifyContainer {...props} />
	</AppContainer>
);

const renderProvision = (props) => (
	<AppContainer {...props}>
		<ProvisionContainer {...props} />
	</AppContainer>
);

const renderUserProvision = (props) => (
	<AppContainer {...props}>
		<UserProvisionContainer {...props} />
	</AppContainer>
);

const routes = () => {
	return (
		<Switch>
			<Route exact path="/" render={renderRoot} />
			<Route path="/project/:id" render={renderUpdate} />
			<Route path="/log/:id" render={renderLog} />
			<Route path="/rotate" render={renderRotatePI} />
			<Route path="/promote" render={renderPromotePI} />
			<Route path="/projects" render={renderProjects} />
			<Route exact path="/create" render={renderCreate} />
			<Route exact path="/ivyvm" render={renderIvyVM} />
			<Route path="/sign" render={renderDocSign} />
			<Route path="/approve" render={renderApproval} />
			<Route path="/verify" render={renderVerify} />
			<Route path="/provision" render={renderProvision} />
			<Route path="/userprovision" render={renderUserProvision} />
		</Switch>
	);
};

export default routes;
